import { AxiosInstance } from 'axios';

import { insertId } from '../insertId';
import { toResponse } from '../genericToResponse';
import { cancellable } from '../cancellable';

export default (api: AxiosInstance, url: string) => (
  emails: string,
  file: File
) => {
  const urlWithEmails = insertId(url, encodeURIComponent(emails));
  const formData = new FormData();
  formData.append('files', file, file.name);

  return cancellable<any>(
    (cancelOptions: any) =>
      api.post(urlWithEmails, formData, {
        ...cancelOptions,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/linkUpload/uploadTemplate.ts